import { Dot } from "@images/svgIcons/charts/dot";
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"
import { v4 as uuidv4 } from 'uuid';

/**
 * Composant for render chart with dots in the Training page
 * @param number
 * @param date
 * @returns
 */
const HuDots = ({ number, date }: { number: number, date: string }) => {
  const gridHeight = 20
  const gridModulo = number % gridHeight
  const gridColumn = Math.floor(number / gridHeight)
  const theme = useTheme()

  return (
    <div className="flex flex-column justify-content-end align-items-center h-full w-3">
      <div className="mb-2">
        <HUText color={theme.mainBlack} fontStyle="TM">
          {number}
        </HUText>
      </div>
      <div>
        <div className="flex flex-row" style={{ gap: "2px" }}>
          {Array.from({ length: gridColumn }).map((_) => (
            <div key={uuidv4()} className="flex flex-column" style={{ gap: "1px" }}>
              {Array.from({ length: gridHeight }).map((_) => (
                <Dot key={uuidv4()} color={theme.mainBlack} />
              ))}
            </div>
          ))}
          {gridModulo > 0 && (
            <div className="flex flex-column-reverse" style={{ gap: "1px" }}>
              {Array.from({ length: gridModulo }).map((_) => (
                <Dot key={uuidv4()} color={theme.mainBlack} />
              ))}
            </div>
          )}

        </div>
      </div>
      <div className="mt-1">
        <HUText color={theme.mainBlack} fontStyle="BS">
          {date}
        </HUText>
      </div>
    </div>
  );
}

export default HuDots
